import { useEffect, useRef } from 'react';
import { OverrideItem } from './OverrideItem';
import './SpecificOverrides.css';
import { getTimeControlInfo } from '../../services/TimeControlsService';
import { useDispatch, useSelector } from 'react-redux';
import { createOverride, selectIdxForms } from '../../../../redux/features/configuration/parts/TimeControlsSlice';
import { useSnackBar } from '../../../../hooks/useSnackBar';

const mockOverrides = [1, 2, 3];

export const SpecificOverrides = ({ overrides, part, timeControl, open }) => {

    const dispatch = useDispatch();
    const {successMsg, infoMsg, warningMsg} = useSnackBar();
    const listRef = useRef(null);
    const timeControlForm  = useSelector((state) => selectIdxForms(state, timeControl.id));

    const addOvr = () => {
        if (timeControlForm.version == 0) {
            warningMsg("Please save the control before adding overrides");
            return;
        }
        infoMsg("Creating Override");
        dispatch(createOverride({controlId: timeControl.id})).then(action => {
            if (action.payload) {
                successMsg("Override created");
                let openEvent = new MouseEvent('click', {
                    bubbles: false,
                    cancelable: true,
                    view: window
                  })
                  listRef.current?.querySelector('summary')?.dispatchEvent(openEvent);
            }
        });
    }

    return (
        <div className='specific-overrides-component'>
            <div className='spec-override-header'>
                <b style={{fontSize: "0.7rem"}}>Specific Overrides</b>
                <button onClick={addOvr} className='outlined icon tiny'>
                    <i className='icon-add-new'></i>
                </button>

            </div>
            <div className='spec-overrides-list' ref={listRef} >
                {overrides?.length > 0 ?

                    overrides?.map(override => <OverrideItem override={override} part={part} key={override.id} controlId={timeControl.id} />)
                    :
                    <div className='placeholder-component white small'>
                        <i>No specific overrides set</i>
                    </div>
                }

            </div>

        </div>
    );

}